var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BasicAlertModal',{attrs:{"isShowModal":_vm.isModal,"btnSubmitText":"확인","handleSubmit":_vm.handleDelete},on:{"close-modal":function($event){return _vm.$store.commit('directMatching/setHideModalPopup')}}},[_vm._v("\n  Are you sure you want to delete, "),_c('br'),_c('br'),_vm._v("\n\n  계속진행하시겠습니까?\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }